<template>
  <Transition
    :css="false"
    @enter="scrollAnimation"
  >
    <section class="about-me scf-main-margins scf-row">
      <div class="scf-row__inner">
        <header class="content-header scf-margin-bottom--xl">
          <h2
            class="content-header__menu-title scf-heading-s scf-margin-bottom--xl"
          >
            About me
          </h2>
          <h1 class="scf-heading-l">
            Sergi Colomer Ferrer
          </h1>
          <p class="scf-body-m">
            Game Developer
          </p>

          <div class="about-me__content">
            <div class="scf-heading-s about-me__content--1-3"></div>
            <div class="about-me__content--2-3">
              <ul class="icon-list scf-list--2col">
                <li>
                  <a
                    href="./pdf/Sergi_Colomer_Ferrer-Programmer-CV.pdf"
                    title="CV Sergi Colomer as Programmer"
                  >
                    <IconSvg icon="pdf" /> Programmer CV
                  </a>
                </li>
                <li>
                  <a
                    href="./pdf/Sergi_Colomer_Ferrer-Designer-CV.pdf"
                    title="CV Sergi Colomer as Designer"
                  >
                    <IconSvg icon="pdf" /> Designer CV
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </header>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Professional Summary
          </h3>

          <div class="about-me__content--2-3 scf-body-m">
            <p>
              I'm a Junior Game Developer focused on programming and design. I live in Girona, Spain and I'm eager to contribute to team success through hard work, attention to detail and excellent organizational skills.
            </p>
            <p>
              During my time in university I have learned numerous concepts regarding game development, having succeeded in creating a great range of projects from a Dynamic Gameplay Adjustment plugin to an entire game engine from scratch.
            </p>
            <p>
              During my work experience I grew as a professional thanks to the mentorship of my team senior with which I learned a wide variety of aspects related with efficient coding, serialization and bugfixing to mention a few.
            </p>
            <p>
              I have worked on many game projects between university and my professional experience and I am extremely motivated to keep learning, growing and being a key asset in future teams.
            </p>
          </div>
        </div>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Skills
          </h3>

          <div class="about-me__content--2-3">
            <ul class="icon-list scf-list--2col">
              <li>
                <h5>Hard Skills</h5>
                <ul class="scf-sublist icon-list">
                  <li><IconSvg icon="cplusplus" /> C++/C#/C Language</li>
                  <li><IconSvg icon="unity" /> Unity</li>
                  <li><IconSvg icon="github" /> GitHub</li>
                  <li><IconSvg icon="unreal" /> Unreal Engine</li>
                  <li><IconSvg icon="dart" /> Dart</li>
                  <li><IconSvg icon="sdl" /> SDL 2.0</li>
                  <li><IconSvg icon="opengl" /> OpenGL</li>
                  <li><IconSvg icon="trello" /> Trello</li>
                  <li>HacknPlan</li>
                  <li>MySQL</li>
                  <li>Scripting</li>
                  <li>Machinations</li>
                  <li>UX Design</li>
                  <li>Prototyping</li>
                  <li>Worldbuilding</li>
                </ul>
              </li>
              <li>
                <h5>Soft Skills</h5>
                <ul class="scf-sublist icon-list">
                  <li>Problem-Solving & Analysis</li>
                  <li>Teamwork</li>
                  <li>Critical Thinking</li>
                  <li>Adaptability</li>
                  <li>Scrum & Agile</li>
                  <li>Creativity</li>
                  <li>Self-Motivated</li>
                  <li>Conflict Resolution</li>
                  <li>Collaboration</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Professional Experience
          </h3>

          <div class="about-me__content--2-3 scf-body-m">
            <p>
              February 2023 - March 2024<br>
              Junior Programmer | <a href="https://evilzeppelin.com/">Evil Zeppelin</a>, Spain
            </p>
            <p>
              I started my time there as a university intern and once the internship ended they offered me a full time contract. I stayed for around a year in total having worked on multiple different projects during my time there.
            </p>
            <p>
              <em>Astral Raiders</em><br>
              Astral Raiders is an idle RPG mecha-themed game. I stayed with this project for the entirety of its development, where I coded various crucial features such as the party selection screen and the game's translation. And some other features like the click/tap effect and some of the game's navigation.
            </p>
            <p>
              <em>Eros Fantasy</em><br>
              Eros Fantasy is a fantasy-themed idle RPG released in 2022. Once Astral Raiders released I moved to this team to help aliviate some of the pressure this team had as even if the game was in maintenance whilst having some live ops events during special dates throughout the year, this team had only one programmer. There, I focused on bug-fixing both gameplay and server issues, some had been known since the release of the game and some were introduced in the latest live ops.
            </p>
          </div>
        </div>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Education
          </h3>

          <div class="about-me__content--2-3 scf-body-m">
            <p>
              September 2019 - July 2024<br>
              Centre De La Imatge I La Tecnologia Multimèdia UPC Barcelona,
              Spain<br>
              Bachelor's Degree in Videogame Design & Development
            </p>
            <p>
              June 2019<br>
              La Salle Girona Girona, Spain<br>
              High School Diploma
            </p>
          </div>
        </div>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Languages
          </h3>

          <div class="about-me__content--2-3">
            <ul class="icon-list scf-list--2col">
              <li>Catalan | Native</li>
              <li>English | C1</li>
              <li>Spanish | B1</li>
            </ul>
          </div>
        </div>

        <div class="about-me__content">
          <h3 class="scf-heading-s about-me__content--1-3">
            Interests
          </h3>

          <div class="about-me__content--2-3 scf-body-m">
            <p>
              In my spare time, I am a DM. I have about 7 years of experience and created all my campaigns and one-shots without any additional material. Dungeons and Dragons is my favorite tabletop game of all time, especially when everyone is having a blast.
            </p>
            <p>
              I love music. I listen to hours upon hours every day. Be it, while
              working, studying or gaming.
            </p>
          </div>
        </div>
      </div>
    </section>
  </Transition>
</template>

<script>
import IconSvg from './IconSvg.vue';

export default {
  name: "AboutMe",
  components: {
    IconSvg,
  },
  mounted: function () {
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="less">
.about-me__content {
  @import "../styles/all.less";

  display: flex;
  flex-direction: column;
  margin-bottom: @scf-space-m;
  gap: @scf-space-sm;

  @media @scf-breakpoints--m {
    flex-direction: row;
    gap: @scf-space-l;
  }

  p {
    em {
            text-decoration: underline;
            text-underline-offset: 2px;
        }
  }

  h5 {
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: @scf-space-s;

    @media @scf-breakpoints--l {
        font-size: 20px;
    }
  }

  .about-me__content--1-3 {
    flex: 1;
    color: @accent-light;

    @media @scf-breakpoints--m {
      text-align: end;
    }
  }
  .about-me__content--2-3 {
    flex: 2;
  }
  .scf-list--2col {
    display: flex;
    flex-direction: column;
    gap: @scf-space-sm; // 20px;

    @media @scf-breakpoints--m {
      flex-direction: row;
    }

    li {
      flex-grow: 1;
    }
  }
  .skills-icon {
    width: @scf-space-m;
    margin-inline-end: @scf-space-2xs; //8px;
  }
  .icon-list {
    list-style: none;
  }
}
</style>
